import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import BootstrapTable from 'react-bootstrap-table-next'
import filterFactory, { selectFilter } from 'react-bootstrap-table2-filter'

import CourseService from '../../../service/courseService'
import StudentCourseService from '../../../service/studentCourseService'
import UserService from '../../../service/userService'
import { errorNotify } from '../../../components/Utils/Toast'
import useToken from '../../../App/useToken'
import './Print.css'

const units = require('../../../utils/UnitJson')
const spcs = require('../../../utils/SpcJson')

export default function Print() {
  const {
    isAdmin,
    isUnitAdminOrUnitSpcAdmin,
    isUnitSpcAdmin,
    getToken,
    getRole,
    getUser,
    isUnitAdmin,
    isAdminViewer,
  } = useToken()
  const isUserAdminViewer = isAdminViewer()
  const token = getToken()
  const role = getRole()
  const { major_name, course_name } = useParams()
  const [unitActive, setUnitActive] = useState()
  const [spcActive, setSpcActive] = useState()
  const [unitCount, setUnitCount] = useState()
  const [spcCount, setSpcCount] = useState()
  const [studentCourses, setStudentCourses] = useState([])
  const [approveRankL, setApproveRankL] = useState()
  const [approveNameL, setApproveNameL] = useState()
  const [approvePositionL, setApprovePositionL] = useState()
  const [approveTelL, setApproveTelL] = useState()
  const [approveRankR, setApproveRankR] = useState()
  const [approveNameR, setApproveNameR] = useState()
  const [approvePositionR, setApprovePositionR] = useState()
  const [approveSubPositionR, setApproveSubPositionR] = useState()
  const [approveTelR, setApproveTelR] = useState()
  const [isSpcApprove, setIsSpcApprove] = useState(
    major_name == 'หลักสูตรนายทหารชั้นผู้บังคับฝูง' ||
      major_name == 'หลักสูตรเสนาธิการกิจเหล่าทัพ' ||
      major_name == 'หลักสูตรระดับการทัพเหล่าทัพ' ||
      major_name == 'หลักสูตรนายทหารอากาศอาวุโส',
  )
  const [isShowYearSos, setIsShowYearSos] = useState(
    major_name == 'หลักสูตรเสนาธิการกิจเหล่าทัพ' ||
      major_name == 'หลักสูตรระดับการทัพเหล่าทัพ' ||
      major_name == 'หลักสูตรนายทหารอากาศอาวุโส',
  )
  const [isVtoSos, setIsVtoSos] = useState(
    major_name == 'หลักสูตรเสนาธิการกิจเหล่าทัพ' ||
    major_name == 'หลักสูตรระดับการทัพเหล่าทัพ',
  )
  // const [majorCourseInfo, setMajorCourseInfo] = useState();
  const [terms, setTerms] = useState([])
  const [termActive, setTermActive] = useState()
  const [owner, setOwner] = useState('')
  const [nameDisplay, setNameDisplay] = useState()
  const [nameDisplay2, setNameDisplay2] = useState()
  const [columnPrint, setColumnPrint] = useState([])
  const [page, setPage] = useState('full')
  const [pageTaxt, setPageTaxt] = useState('แสดงฉบับย่อ')
  const [isStudentCourseApprove, setIsStudentCourseApprove] = useState(false)
  const [studentCourseApproveAt, setStudentCourseApproveAt] = useState()
  const isUserAdmin = isAdmin()
  const isUserUnitAdmin = isUnitAdmin()
  const user = getUser()
  const isUserUnitAdminOrUnitSpcAdmin = isUnitAdminOrUnitSpcAdmin()
  const isUserUnitSpcAdmin = isUnitSpcAdmin()
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [columnData, setColumnData] = useState([])

  const getStudentCourse = async () => {
    const studentCourseService = new StudentCourseService()
    const res = await studentCourseService.getStudentCourseByCourseName({
      course_name,
      token,
    })
    setTerms(res?.terms)
    if (res?.studentInTermcourse) {
      setStudentCourses(res.studentInTermcourse)
      setIsStudentCourseApprove(res.isStudentCourseApprove)
      setStudentCourseApproveAt(res.studentCourseApproveAt)
    } else {
      errorNotify('เกิดข้อผิดพลาด')
    }
    return res
  }
  const getUserSetting = async () => {
    const userService = new UserService()
    const res = await userService.getUserSetting({
      token,
    })
    if (res?.email) {
      setApproveRankL(res.approveRankL)
      setApproveNameL(res.approveNameL)
      setApprovePositionL(res.approvePositionL)
      setApproveTelL(res.approveTelL)
      setApproveRankR(res.approveRankR)
      setApproveNameR(res.approveNameR)
      setApprovePositionR(res.approvePositionR)
      setApproveSubPositionR(res.approveSubPositionR)
      setApproveTelR(res.approveTelR)
    } else {
      errorNotify('เกิดข้อผิดพลาด')
    }
  }

  const rowClasses = (row) => {
    let classes = ''
    switch (role) {
      case 'admin':
        if (!row.is_pass_qualification) {
          classes = 'not-qualified '
        }
        break
      case 'adminViewer':
        if (!row.is_pass_qualification) {
          classes = 'not-qualified '
        }
        break
      case 'adminUnit':
        if (!row.unit_is_pass_qualification) {
          classes = 'not-qualified '
        }
        break
      case 'adminUnitSpc':
        if (!row.spc_is_pass_qualification) {
          classes = 'not-qualified '
        }
        break
    }
    classes += `${row.airforceId} ${row.unit_no} ${row.spcNo} ${row.unitSpcNo}`

    return classes
  }

  function indexFormatter(cell, row) {
    if (row.note && isUserAdmin) {
      return <span>{cell} * </span>
    }
    return <span>{cell}</span>
  }

  const columnShot = [
    {
      dataField: 'is_pass_qualification',
      headerClasses: 'qualification',
      text: 'คุณสมบัติ',
    },
    {
      dataField: 'index',
      headerClasses: 'index',
      text: '#',
      formatter: indexFormatter,
    },
    {
      dataField: 'rankAbbrName',
      headerClasses: 'rank-abbr-name',
      text: 'ยศ',
    },
    {
      dataField: 'fullName',
      headerClasses: 'full-name',
      text: 'ชื่อ-นามสกุล',
    },
    {
      dataField: 'unit_no',
      headerClasses: 'org-abbr-name',
      text: `นขต.ทอ. ${
        unitCount != studentCourses.length && unitCount != undefined
          ? '(' + unitCount + ')'
          : ''
      }`,
      formatter: (cell) => units[cell],
      filter: selectFilter({
        options: units,
        onFilter: (filterValue, rows) => {
          setUnitActive(filterValue)
          const filter = rows.filter((e) => e.unit_no == filterValue)
          setUnitCount(filter.length)
          if (filterValue == '') setUnitCount(studentCourses.length)
        },
      }),
    },
    {
      dataField: 'spcNo',
      headerClasses: 'spc-name',
      text: `สายวิทยาการ ${
        spcCount != studentCourses.length && spcCount != undefined
          ? '(' + spcCount + ')'
          : ''
      }`,
      formatter: (cell) => spcs[cell],
      filter: selectFilter({
        options: spcs,
        onFilter: (filterValue, rows) => {
          setSpcActive(filterValue)
          const filter = rows.filter((e) => e.spcNo == filterValue)
          setSpcCount(filter.length)
          if (filterValue == '') setSpcCount(studentCourses.length)
        },
      }),
    },
  ]

  useEffect(async () => {
    setColumnPrint(columns)
    let ownerTemp = ''
    if (isUserAdmin) {
      setOwner('ของ กพ.ทอ.')
      ownerTemp = 'ของ กพ.ทอ.'
    } else if (isUserUnitSpcAdmin) {
      setOwner(`หน่วย หน.สายวิทยาการ ${JSON.parse(user).unitSpcName}`)
      ownerTemp = `หน่วย หน.สายวิทยาการ ${JSON.parse(user).unitSpcName}`
    } else {
      setOwner(`หน่วย ${JSON.parse(user).unit}`)
      ownerTemp = `หน่วย ${JSON.parse(user).unit}`
    }

    getStudentCourse()
    getUserSetting()
    const courseNameArray = course_name.split('-')
    setNameDisplay(`${courseNameArray[0]} ประจำปี ${courseNameArray[1]}`)
    setNameDisplay2(ownerTemp)
    setTermActive(terms[0]?.id)
    setIsLoadingData(false)
  }, [])

  const columns = [
    {
      dataField: 'is_pass_qualification',
      headerClasses: 'qualification',
      text: 'คุณสมบัติ',
    },
    {
      dataField: 'index',
      headerClasses: 'index',
      text: '#',
      formatter: indexFormatter,
    },
    {
      dataField: 'rankAbbrName',
      headerClasses: 'rank-abbr-name',
      text: 'ยศ',
    },
    {
      dataField: 'fullName',
      headerClasses: 'full-name',
      text: 'ชื่อ-นามสกุล',
    },
    {
      dataField: 'unit_no',
      headerClasses: 'org-abbr-name',
      text: `นขต.ทอ. ${
        unitCount != studentCourses.length && unitCount != undefined
          ? '(' + unitCount + ')'
          : ''
      }`,
      formatter: (cell) => units[cell],
      filter: selectFilter({
        options: units,
        onFilter: (filterValue, rows) => {
          setUnitActive(filterValue)
          const filter = rows.filter((e) => e.unit_no == filterValue)
          setUnitCount(filter.length)
          if (filterValue == '') setUnitCount(studentCourses.length)
        },
      }),
    },
    {
      dataField: 'spcNo',
      headerClasses: 'spc-name',
      text: `สายวิทยาการ ${
        spcCount != studentCourses.length && spcCount != undefined
          ? '(' + spcCount + ')'
          : ''
      }`,
      formatter: (cell) => spcs[cell],
      filter: selectFilter({
        options: spcs,
        onFilter: (filterValue, rows) => {
          setSpcActive(filterValue)
          const filter = rows.filter((e) => e.spcNo == filterValue)
          setSpcCount(filter.length)
          if (filterValue == '') setSpcCount(studentCourses.length)
        },
      }),
    },
    {
      dataField: 'age',
      headerClasses: 'age',
      text: 'อายุ',
    },
    {
      dataField: 'seniorOfRank',
      headerClasses: 'senior-of-rank',
      text: 'ระยะเวลาการครองยศ',
    },
    {
      dataField: 'bornEduName',
      headerClasses: 'born-edu',
      text: 'คุณวุฒิที่ใช้บรรจุ',
    },
    {
      dataField: 'degreeAbbrName',
      headerClasses: 'degree-abbr',
      text: 'คุณวุฒิสูงสุด',
    },
    {
      dataField: 'ecl_score',
      headerClasses: 'ecl-score',
      text: 'คะแนนภาษาอังกฤษ',
      formatter: (cell) => {
        return cell || '-'
      },
    },
    {
      dataField: 'health',
      headerClasses: 'health',
      text: 'ผลการตรวจร่างกาย',
      formatter: (cell) => {
        if (cell == undefined) {
          return '-'
        }
        return cell ? 'ผ่าน' : 'ไม่ผ่าน'
      },
    },
  ]
  if (isUserUnitAdmin) {
    columns.push(
      {
        dataField: 'positionAddDateUnit',
        headerClasses: 'position-add-date-unit',
        text: 'สิทธิ์เข้าอัตราหน่วย',
        formatter: (cell) => {
          const d = new Date(cell)
          return cell
            ? d.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'short',
              })
            : '-'
        },
      },
      {
        dataField: 'positionAddUnit',
        headerClasses: 'position-add-unit-spc',
        text: 'ตำแหน่งที่จะย้ายเข้าหน่วย',
        formatter: (cell) => {
          return cell || '-'
        },
      },
    )
  }
  if (isUserUnitSpcAdmin || isUserAdmin || isUserAdminViewer) {
    columns.push(
      {
        dataField: 'levelUpPlanUnitText',
        headerClasses: 'level-up-plan-unit',
        text: 'แผนสิทธิ์เข้าอัตราหน่วย',
        formatter: (cell) => {
          return cell || '-'
        },
      },
      {
        dataField: 'levelUpPlanUnitSpcText',
        headerClasses: 'level-up-plan-unit-spc',
        text: 'แผนสิทธิ์เข้าอัตราสาย',
        formatter: (cell) => {
          return cell || '-'
        },
      },
      {
        dataField: 'positionAddDateUnit',
        headerClasses: 'position-add-date-unit',
        text: 'สิทธิ์เข้าอัตราหน่วย',
        formatter: (cell) => {
          const d = new Date(cell)
          return cell
            ? d.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'short',
              })
            : '-'
        },
      },
      {
        dataField: 'positionAddDateUnitSpc',
        headerClasses: 'position-add-date-unit-spc',
        text: 'สิทธิ์เข้าอัตราสาย',
        formatter: (cell) => {
          const d = new Date(cell)
          return cell
            ? d.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'short',
              })
            : '-'
        },
      },
      {
        dataField: 'positionAddUnit',
        headerClasses: 'position-add-unit',
        text: 'ตำแหน่งที่จะย้ายเข้าหน่วย',
        formatter: (cell) => {
          return cell || '-'
        },
      },
      {
        dataField: 'positionAddUnitSpc',
        headerClasses: 'position-add-unit-spc',
        text: 'ตำแหน่งที่จะย้ายเข้าสาย',
        formatter: (cell) => {
          return cell || '-'
        },
      },
    )
  }
  if (isUserUnitAdminOrUnitSpcAdmin || isUserAdmin || isUserAdminViewer) {
    columns.push({
      dataField: 'unit_order',
      headerClasses: 'unit-order',
      text: 'ลำดับหน่วย',
      formatter: (cell) => {
        return cell || '-'
      },
    })
  }
  if (
    (isUserAdmin || isUserAdminViewer || isUserUnitSpcAdmin) &&
    isSpcApprove
  ) {
    columns.push({
      dataField: 'spc_order',
      headerClasses: 'spc-order',
      text: 'ลำดับสาย',
      formatter: (cell) => {
        return cell || '-'
      },
    })
  }
  if (isUserAdmin || isUserAdminViewer) {
    columns.push({
      dataField: 'order',
      headerClasses: 'order',
      text: 'ลำดับ กพ.',
      formatter: (cell) => {
        return cell || '-'
      },
    })
  }
  if (isUserUnitSpcAdmin || isUserAdmin || isUserAdminViewer) {
    columns.push({
      dataField: 'unit_term_text',
      headerClasses: 'unit-term',
      text: 'รุ่นหน่วย',
      formatter: (cell) => {
        return cell || '-'
      },
    })
  }
  if ((isUserAdmin || isUserAdminViewer) && isSpcApprove) {
    columns.push({
      dataField: 'line_term_text',
      headerClasses: 'line-term',
      text: 'รุ่นสาย',
      formatter: (cell) => {
        return cell || '-'
      },
    })
  }
  if (isShowYearSos) {
    columns.push({
      dataField: 'pme_data.YEAR_SUCCESS_SOS',
      headerClasses: 'line-term',
      text: 'ปีจบ นฝ.',
      formatter: (cell) => {
        return cell || '-'
      },
    })
  }
  if (isUserUnitSpcAdmin && isSpcApprove) {
    columns.push(
      {
        dataField: 'line_term_text',
        headerClasses: 'line-term',
        text: 'รุ่นสาย',
        formatter: (cell) => {
          return cell || '-'
        },
      },
      {
        dataField: 'unit_is_pass_qualification_text',
        headerClasses: 'unit-is-pass-qualification-text',
        classes: 'unit-is-pass-qualification-text',
        text: 'คุณสมบัติ',
        formatter: (cell) => {
          return cell || '-'
        },
      },
      {
        dataField: 'unit_note',
        headerClasses: 'unit-note',
        classes: 'note',
        text: 'หมายเหตุ',
        formatter: (cell) => {
          return cell || '-'
        },
      },
    )
  }
  if (isUserAdmin || isUserAdminViewer) {
    columns.push(
      {
        dataField: 'term_text',
        headerClasses: 'term',
        text: 'สรุปรุ่น',
        formatter: (cell) => {
          return cell || '-'
        },
      },
      {
        dataField: 'unit_is_pass_qualification_text',
        headerClasses: 'unit-is-pass-qualification-text',
        classes: 'unit-is-pass-qualification-text',
        text: 'คุณสมบัติ',
        formatter: (cell) => {
          return cell || '-'
        },
      },
      {
        dataField: 'unit_note',
        headerClasses: 'unit-note',
        classes: 'note',
        text: 'หมายเหตุ',
        formatter: (cell) => {
          return cell || '-'
        },
      },
    )
  }
  if (role === 'adminUnit') {
    columns.push(
      {
        dataField: 'unit_term_text',
        headerClasses: 'unit-term',
        text: 'รุ่นหน่วย',
        formatter: (cell) => {
          return cell || '-'
        },
      },
      {
        dataField: 'unit_is_pass_qualification_text',
        headerClasses: 'unit-is-pass-qualification-text',
        classes: 'unit-is-pass-qualification-text',
        text: 'คุณสมบัติ',
        formatter: (cell) => {
          return cell || '-'
        },
      },
      {
        dataField: 'unit_note',
        headerClasses: 'unit-note',
        classes: 'note',
        text: 'หมายเหตุ',
        formatter: (cell) => {
          return cell || '-'
        },
      },
    )
  }

  // setColumnPrint(columns);

  const handleClickActiveTab = (term) => {
    const courseNameArray = course_name.split('-')
    setTermActive(term.id)
    if (term.index == 0) {
      setNameDisplay(`${courseNameArray[0]} ประจำปี ${courseNameArray[1]}`)
      setNameDisplay2(owner)
    } else if (term.id == 'reserve') {
      setNameDisplay(
        `${courseNameArray[0]} สำรอง ประจำปี ${courseNameArray[1]}`,
      )
      setNameDisplay2(owner)
    } else {
      setNameDisplay(
        `${courseNameArray[0]} ${!isVtoSos ? term.prefix + ' ' : ''}${term.name} ประจำปี ${courseNameArray[1]}`,
      )
      setNameDisplay2(owner)
    }
  }

  const handlePage = () => {
    if (page === 'shot') {
      setColumnPrint(columns)
      setPageTaxt('แสดงฉบับย่อ')
      setPage('full')
    } else {
      setColumnPrint(columnShot)
      setPageTaxt('แสดงฉบับเต็ม')
      setPage('shot')
    }
  }

  useEffect(() => {
    if (page === 'shot') {
      setColumnPrint(columnShot)
    } else {
      setColumnPrint(columns)
    }
  }, [unitCount, spcCount])

  const handleOnGenerateResultOrder = async (isAdminReq) => {
    console.log('isAdminReq', isAdminReq)
    const studentCourseService = new StudentCourseService()
    const res = await studentCourseService.generateeResultOrderByCourseName({
      course_name,
      nameDisplay,
      nameDisplay2,
      termActive,
      unitActive,
      spcActive,
      approveRankL,
      approveNameL,
      approvePositionL,
      approveTelL,
      approveRankR,
      approveNameR,
      approvePositionR,
      approveSubPositionR,
      approveTelR,
      token,
      isAdminReq,
    })
    if (res.name) {
      const courseService = new CourseService()
      setTimeout(async () => {
        const dowloadLink = await courseService.dowloadFile('report', res.name)
        console.log('dowloadLink', dowloadLink)
        window.open(dowloadLink)
      }, 2000)
    }
  }

  return (
    <div className='main-container'>
      <center className='course-name'>
        {nameDisplay} {nameDisplay2}
      </center>
      <span className='water-mark'>
        เอกสารฉบับนี้จัดทำผ่านระบบรับสมัครคัดเลือกข้าราชการเข้ารับการศึกษาหลักสูตรหลักของ
        ทอ.
        <br />
        (EDU-CENTER.RTAF.MI.TH)
      </span>
      <div className='sign'>
        {!isUserAdmin && (
          <div className='sign1'>
            <span className='term-condition'>
              ขอรับรองว่าผู้สมัครเข้ารับการศึกษามีคุณสมบัติถูกต้อง
              และไม่ติดราชการ หรือต้องหาคดี <br />
              หรือศึกษาหลักสูตรอื่นใดในห้วงเวลาเดียวกับหลักสูตรหลักของ ทอ.
            </span>
            <div className='sign-container1'>
              <input
                className='sign-input1'
                placeholder='น.ต.'
                value={approveRankL}
                onChange={(e) => setApproveRankL(e.target.value)}
                type='text'
                size='30'
              />
              <input
                className='sign-label-name'
                placeholder='(ทวีพร จิตรอักษร)'
                value={approveNameL}
                onChange={(e) => setApproveNameL(e.target.value)}
                type='text'
                size='30'
              />
              <center>
                <input
                  className='sign-label1'
                  placeholder='นายทหารกำลังพล'
                  value={approvePositionL}
                  onChange={(e) => setApprovePositionL(e.target.value)}
                  size='30'
                  type='text'
                />
              </center>
              <center>
                <span className='today-date'>
                  {new Date().toLocaleString('th-TH')}
                </span>
              </center>
              <input
                className='sign-label1'
                placeholder='โทร.x-xxxx'
                value={approveTelL}
                onChange={(e) => setApproveTelL(e.target.value)}
                type='text'
                size='30'
              />
            </div>
          </div>
        )}
        <div className={isUserAdmin ? 'sign2-admin' : 'sign2'}>
          <span className='term-condition'>ตรวจถูกต้อง</span>
          <br />
          <div className='sign-container2'>
            <input
              className='sign-input2'
              placeholder='น.ท.'
              value={approveRankR}
              onChange={(e) => setApproveRankR(e.target.value)}
              type='text'
              size='30'
            />
            <input
              className='sign-label-name'
              placeholder='(บุรีรัตน์ เข็มทอง)'
              value={approveNameR}
              onChange={(e) => setApproveNameR(e.target.value)}
              type='text'
              size='30'
            />
            <input
              className='sign-label2'
              placeholder='หน.นขต.ทอ/สายวิทยาการ หรือผู้ได้รับมอบหมาย'
              value={approvePositionR}
              onChange={(e) => setApprovePositionR(e.target.value)}
              size='45'
              type='text'
            />
            <input
              className='sign-sub-label2'
              placeholder='*ตำแหน่งทำการแทน'
              value={approveSubPositionR}
              onChange={(e) => setApproveSubPositionR(e.target.value)}
              size='45'
              type='text'
            />
            {!isUserAdmin && (
              <center>
                <span className='today-date'>
                  {new Date().toLocaleString('th-TH')}
                </span>
              </center>
            )}
            <center>
              <input
                className='sign-label2'
                placeholder='โทร.x-xxxx'
                value={approveTelR}
                onChange={(e) => setApproveTelR(e.target.value)}
                type='text'
                size='30'
              />
            </center>
          </div>
        </div>
      </div>
      <div className='btn-container'>
        <Button
          variant='secondary'
          className='btn-sm handle-page-btn'
          onClick={handlePage}>
          {pageTaxt}
        </Button>
        {(isUserAdmin || isUserAdminViewer) && (
          <Button
            variant='secondary'
            className='btn-sm print-btn'
            onClick={(e) => handleOnGenerateResultOrder(true)}>
            ออกคำสั่ง
          </Button>
        )}
        <Button
          variant='secondary'
          className='btn-sm print-btn'
          onClick={(e) => handleOnGenerateResultOrder(false)}>
          พิมพ์ผลจัดเรียงส่ง นกข.
        </Button>
      </div>
      {(isUserAdmin || isUserAdminViewer || isUserUnitAdminOrUnitSpcAdmin) &&
        !isLoadingData && (
          <div className='student-container-group'>
            <div className='student-container'>
              {/* <div style={{ width: '90rem' }}> */}
              <div>
                {studentCourses != [] && (
                  <Tabs>
                    <TabList>
                      {terms.map((term, index) => (
                        <Tab
                          key={term.id}
                          onClick={() => handleClickActiveTab(term)}>
                          <span>
                            {term.prefix} {term.name} ({term.suffixAmount})
                          </span>
                        </Tab>
                      ))}
                    </TabList>

                    {studentCourses.map((studentCourse, index) => (
                      <>
                        {terms.length > 0 && (
                          <TabPanel key={index}>
                            <BootstrapTable
                              rowClasses={rowClasses}
                              striped
                              bordered={false}
                              keyField='id'
                              data={studentCourse.data}
                              columns={columnPrint}
                              filter={filterFactory()}
                              noDataIndication='-----ไม่พบข้อมูล-----'
                              bootstrap4
                              key={index}
                              classes='student-course-table'
                            />
                          </TabPanel>
                        )}
                      </>
                    ))}
                  </Tabs>
                )}
              </div>
            </div>
          </div>
        )}
    </div>
  )
}
